export function prettyJson(obj) {
    return JSON.stringify(Object.assign({}, obj), null, 4);
}
export function isAttributeTrue(val) {
    const isStringTrue = typeof val === "string" && val === "true";
    const isBoolean = typeof val === "boolean" && val;
    return isStringTrue || isBoolean;
}
